import { UtcDate } from '@/helpers/date';

export default {
  computesRequired: true,
  validate: (value) => {
    let valid = true;

    const todayUtc = new UtcDate();
    const birthDate = new UtcDate(value);

    const isAgeInFuture = birthDate.isAfter(todayUtc);
    if (isAgeInFuture) valid = false;

    return {
      valid,
      required: true,
    };
  },
  message: (fieldName, { _value_: v }) => {
    let defaultMsg = 'Please select date of birth.';
    if (!v) return defaultMsg;
    const todayUtc = new UtcDate();
    const birthDate = new UtcDate(v);

    const isAgeInFuture = birthDate.isAfter(todayUtc);
    if (isAgeInFuture) defaultMsg = 'Please choose a date that is not in the future.';

    if (!birthDate.isValid()) return 'Invalid format for date of birth.';
    return defaultMsg;
  },
};
